var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.883 5.183l6.75-2.071a1.25 1.25 0 01.734 0l6.75 2.07c.525.162.883.647.883 1.196v5.621c0 5.706-6.08 8.303-7.64 8.876a1.04 1.04 0 01-.72 0C10.08 20.302 4 17.705 4 11.999V6.378c0-.55.358-1.034.883-1.195z",
    fill: "#ADC9FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2E2E2E"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.894 3.007A1.25 1.25 0 001 4.206V12c0 7.798 8.784 11.241 10.653 11.886.23.079.465.079.694 0C14.217 23.242 23 19.799 23 12V4.206a1.25 1.25 0 00-.894-1.199l-9.75-2.9a1.25 1.25 0 00-.713 0l-9.75 2.9zm.356 1.199V12c0 3.37 1.884 5.857 4.15 7.644 2.22 1.751 4.672 2.715 5.6 3.04.928-.325 3.38-1.289 5.6-3.04 2.266-1.787 4.15-4.273 4.15-7.644V4.206L12 1.305l-9.75 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.367 3.113a1.25 1.25 0 00-.734 0l-6.75 2.071A1.25 1.25 0 004 6.38v5.622c0 5.706 6.08 8.303 7.64 8.875.234.086.486.086.72 0C13.92 20.304 20 17.706 20 12V6.38a1.25 1.25 0 00-.883-1.196l-6.75-2.071zM12 4.308L5.25 6.379v5.622c0 2.354 1.24 4.11 2.787 5.404 1.508 1.261 3.205 1.988 3.963 2.272.758-.284 2.455-1.011 3.963-2.272C17.51 16.11 18.75 14.355 18.75 12V6.38L12 4.307z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.941 11.766a2 2 0 10-1.882 0l-.904 3.613a.5.5 0 00.485.621h2.72a.5.5 0 00.485-.62l-.904-3.614z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.67a033b71f7c20be2fcbb4acbf3f7089.svg";
export { ForwardRef as ReactComponent };